import React from 'react';
import { FormattedMessage } from 'react-intl';

import { AtlassianLogo } from '@atlaskit/logo';
import { B200, B400, N700 } from '@atlaskit/theme/colors';

import { messages } from '../messages';

export function DefaultHeader() {
  return (
    <AtlassianLogo
      size="medium"
      textColor={N700}
      iconColor={B200}
      iconGradientStart={B400}
      iconGradientStop={B200}
      label={<FormattedMessage {...messages.atlassianLogoLabel} />}
    />
  );
}
